const axios = require('axios');

export default {
    // Authentication
    authenticate (cb, credentials, uuid) {
        axios({
            method: 'post',
            url: 'https://api-prestalis-nps.dif.pw/authenticate',
            //url: 'https://api.prestalis-nps.local/authenticate',
            data: {
                username: credentials.username,
                password: credentials.password,
                device_uuid: uuid,
            }
        }).then(response => (cb(response)))
            .catch(error => cb(error));
    },

    // Sync Survey
    getSurveys (cb, session_token) {
        axios({
            method: 'post',
            // url: 'https://api.prestalis-nps.local/getSurveys',
            url: 'https://api-prestalis-nps.dif.pw/getSurveys',
            data: {
                session_token: session_token
            }
        }).then(response => (cb(response)))
            .catch(error => cb(error));
    },

    // Record survey
    recordSurvey (cb, session_token, payload) {
        axios({
            method: 'post',
            //url: 'https://api.prestalis-nps.local/recordSurvey',
            url: 'https://api-prestalis-nps.dif.pw/recordSurvey',
            data: {
                session_token: session_token,
                payload: payload
            }
        }).then(response => (cb(response)))
            .catch(error => cb(error));
    },

    // Sync Survey
    syncSurveys (cb, session_token, payload) {
        axios({
            method: 'post',
            // url: 'https://api.prestalis-nps.local/syncSurvey',
            url: 'https://api-prestalis-nps.dif.pw/syncSurvey',
            data: {
                session_token: session_token,
                payload: payload
            }
        }).then(response => (cb(response)))
            .catch(error => cb(error));
    }

}





